export class DownloadRequest {
  type: string;
  onlyNew: boolean;
  parents: string[];
  stores: string[];
  invoices: string[];
  pipe: boolean;
}
